
export const DEFAULT_APPROVAL_REQUESTS_GROUPS = {
  open: [],
  approved: [],
  pending: [],
  rejected: [],
}